import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { numberOf } from '../shared/bounds';
import { inListOrder, inRow } from '../shared/choice';
import { FillInputProps } from '../fillInput';

export const CheckboxGroupInput = (props: FillInputProps<readonly string[], object>) => {
  const { options, value, onChange, inputId, describedBy, disabled, error } = props;
  const max = numberOf(props.bounds.max);
  const atMax = max !== undefined && value.length >= max;
  const toggle = (optionId: string, checked: boolean) =>
    onChange(inListOrder(checked ? [...value, optionId] : value.filter(id => id !== optionId), options));
  return (
    <FormGroup id={inputId} row={inRow(options)}>
      {options.map(option => {
        const checked = value.includes(option.id);
        return (
          <FormControlLabel
            key={option.id}
            label={option.label}
            disabled={disabled || (atMax && !checked)}
            control={
              <Checkbox
                checked={checked}
                onChange={event => toggle(option.id, event.target.checked)}
                slotProps={{ input: { 'aria-describedby': describedBy, 'aria-invalid': error } }}
              />
            }
          />
        );
      })}
    </FormGroup>
  );
};
